import { Button, Field, FileField, Input, Loader } from '@itds/elements/index.js';
import React, { useState } from 'react';

import { PropTypes } from 'prop-types';

const BuildCredentials = ({ updateMobileApp, loading, mobile_app }) => {
  const [input_fields, setInputFields] = useState({
    android_app_name: mobile_app.android_app_name,
    android_build_version_code: mobile_app.android_build_version_code,
    android_key_alias: mobile_app.android_key_alias,
    android_key_pw: mobile_app.android_key_pw,
    android_keystore_pw: mobile_app.android_keystore_pw,
    android_package_name: mobile_app.android_package_name,
    build_version_name: mobile_app.build_version_name,
    google_keystore: null,
    ios_app_name: mobile_app.ios_app_name,
    ios_build_version_number: mobile_app.ios_build_version_number,
    ios_bundle_id: mobile_app.ios_bundle_id,
    ios_distribution_certificate_key: mobile_app.ios_distribution_certificate_key,
    ios_distribution_certificate: null,
    ios_provisioning_profile_name: mobile_app.ios_provisioning_profile_name,
    ios_provisioning_profile: null,
    ios_push_certificate: null,
    ios_team_id: mobile_app.ios_team_id
  });

  // const [errors, setErrors] = useState([]);

  const _handleChangeInput = (name, e) => {
    setInputFields({ ...input_fields, [name]: e.target.value });
  };

  const _handleChangeFile = (name, file) => {
    setInputFields({ ...input_fields, [name]: file });
  };

  const _handleKeyDown = e => {
    return e.keyCode === 13 ? _handleSave() : null;
  };

  const _handleSave = () => {
    updateMobileApp(input_fields);

    setInputFields({
      ...input_fields,
      google_keystore: null,
      ios_distribution_certificate: null,
      ios_provisioning_profile: null,
      ios_push_certificate: null
    });
    window.scrollTo(0, 0);
    // const errors = [];

    // if (!fields.build_version_name) {
    //   errors.push('build_version_name');
    // }

    // if (errors.length) {
    //   setErrors(errors);
    // } else {
    //   setErrors([]);
    //   updateMobileApp(fields);
    // }
  };

  const viewFile = url => {
    window.open(url);
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <Field label='Google Keystore'>
        <FileField
          file={input_fields.google_keystore}
          fileUrl={mobile_app.google_keystore.url}
          onChange={_handleChangeFile.bind(null, 'google_keystore')}
        />
        {mobile_app.google_keystore && mobile_app.google_keystore.url ? (
          <Button
            inline={true}
            onClick={viewFile.bind(null, mobile_app.google_keystore.url)}
            small={true}
            style={{ marginTop: '5px' }}
          >
            View File
          </Button>
        ) : null}
      </Field>
      <Field label='iOS Provisioning Profile'>
        <FileField
          file={input_fields.ios_provisioning_profile}
          fileUrl={mobile_app.ios_provisioning_profile.url}
          onChange={_handleChangeFile.bind(null, 'ios_provisioning_profile')}
        />
        {mobile_app.ios_provisioning_profile && mobile_app.ios_provisioning_profile.url ? (
          <Button
            inline={true}
            onClick={viewFile.bind(null, mobile_app.ios_provisioning_profile.url)}
            small={true}
            style={{ marginTop: '5px' }}
          >
            View File
          </Button>
        ) : null}
      </Field>
      <Field label='iOS Push Certificate'>
        <FileField
          file={input_fields.ios_push_certificate}
          fileUrl={mobile_app.ios_push_certificate.url}
          onChange={_handleChangeFile.bind(null, 'ios_push_certificate')}
        />
        {mobile_app.ios_push_certificate && mobile_app.ios_push_certificate.url ? (
          <Button
            inline={true}
            onClick={viewFile.bind(null, mobile_app.ios_push_certificate.url)}
            small={true}
            style={{ marginTop: '5px' }}
          >
            View File
          </Button>
        ) : null}
      </Field>
      <Field label='iOS Distribution Certificate'>
        <FileField
          file={input_fields.ios_distribution_certificate}
          fileUrl={mobile_app.ios_distribution_certificate.url}
          onChange={_handleChangeFile.bind(null, 'ios_distribution_certificate')}
        />
        {mobile_app.ios_distribution_certificate && mobile_app.ios_distribution_certificate.url ? (
          <Button
            inline={true}
            onClick={viewFile.bind(null, mobile_app.ios_distribution_certificate.url)}
            small={true}
            style={{ marginTop: '5px' }}
          >
            View File
          </Button>
        ) : null}
      </Field>
      <Field label='Build Version Name'>
        <Input
          // invalid={errors.includes('build_version_name')}
          onChange={_handleChangeInput.bind(null, 'build_version_name')}
          onKeyDown={_handleKeyDown}
          value={input_fields.build_version_name}
        />
      </Field>
      <Field label='Android Build Version Code'>
        <Input
          onChange={_handleChangeInput.bind(null, 'android_build_version_code')}
          onKeyDown={_handleKeyDown}
          value={input_fields.android_build_version_code}
        />
      </Field>
      <Field label='iOS Build Version Number'>
        <Input
          onChange={_handleChangeInput.bind(null, 'ios_build_version_number')}
          onKeyDown={_handleKeyDown}
          value={input_fields.ios_build_version_number}
        />
      </Field>
      <Field label='iOS App Name'>
        <Input
          onChange={_handleChangeInput.bind(null, 'ios_app_name')}
          onKeyDown={_handleKeyDown}
          value={input_fields.ios_app_name}
        />
      </Field>
      <Field label='iOS Builde ID'>
        <Input
          onChange={_handleChangeInput.bind(null, 'ios_bundle_id')}
          onKeyDown={_handleKeyDown}
          value={input_fields.ios_bundle_id}
        />
      </Field>
      <Field label='iOS Distribution Certificate Key'>
        <Input
          onChange={_handleChangeInput.bind(null, 'ios_distribution_certificate_key')}
          onKeyDown={_handleKeyDown}
          value={input_fields.ios_distribution_certificate_key}
        />
      </Field>
      <Field label='iOS Provisioning Profile Name'>
        <Input
          onChange={_handleChangeInput.bind(null, 'ios_provisioning_profile_name')}
          onKeyDown={_handleKeyDown}
          value={input_fields.ios_provisioning_profile_name}
        />
      </Field>
      <Field label='Android App Name'>
        <Input
          onChange={_handleChangeInput.bind(null, 'android_app_name')}
          onKeyDown={_handleKeyDown}
          value={input_fields.android_app_name}
        />
      </Field>
      <Field label='Android Package Name'>
        <Input
          onChange={_handleChangeInput.bind(null, 'android_package_name')}
          onKeyDown={_handleKeyDown}
          value={input_fields.android_package_name}
        />
      </Field>
      <Field label='Android Keystore Password'>
        <Input
          onChange={_handleChangeInput.bind(null, 'android_keystore_pw')}
          onKeyDown={_handleKeyDown}
          value={input_fields.android_keystore_pw}
        />
      </Field>
      <Field label='Android Key Alias'>
        <Input
          label='android key alias'
          onChange={_handleChangeInput.bind(null, 'android_key_alias')}
          onKeyDown={_handleKeyDown}
          value={input_fields.android_key_alias}
        />
      </Field>
      <Field label='Android Key PW'>
        <Input
          onChange={_handleChangeInput.bind(null, 'android_key_pw')}
          onKeyDown={_handleKeyDown}
          value={input_fields.android_key_pw}
        />
      </Field>
      <Field label='iOS Team ID'>
        <Input
          onChange={_handleChangeInput.bind(null, 'ios_team_id')}
          onKeyDown={_handleKeyDown}
          value={input_fields.ios_team_id}
        />
      </Field>

      <Button inline={true} onClick={_handleSave}>
        Save
      </Button>
    </>
  );
};

BuildCredentials.propTypes = {
  loading: PropTypes.bool,
  mobile_app: PropTypes.object,
  updateForm: PropTypes.func,
  updateMobileApp: PropTypes.func
};

export default BuildCredentials;
